import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const LevelCapexService = {
  // Level 1 endpoints
  getLevels1: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level1capex/getlevels1`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel1: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level1capex/updatelevel1`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel1: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level1capex/insertlevel1`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel1: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level1capex/deletelevel1?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Level 2 endpoints
  getLevels2: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level2capex/getlevels2`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Missing method 1: Get Level 2 by Level 1
  getLevels2ByLevel1: async (level1Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level2capex/getlevel2bylevel1?level1Code=${level1Code}`
      );
      return data;
    } catch (error) {
      console.error("Error fetching level2 by level1:", error);
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel2: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level2capex/updatelevel2`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel2: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level2capex/insertlevel2`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel2: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level2capex/deletelevel2?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Level 3 endpoints
  getLevels3: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level3capex/getlevels3`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Missing method 2: Get Level 3 by Level 2
  getLevels3ByLevel2: async (level2Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level3capex/getlevel3bylevel2?level2Code=${level2Code}`
      );
      return data;
    } catch (error) {
      console.error("Error fetching level3 by level2:", error);
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel3: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level3capex/updatelevel3`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel3: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level3capex/insertlevel3`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel3: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level3capex/deletelevel3?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default LevelCapexService;
